import script from "./SalesmanReturnOrderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanReturnOrderForm.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanReturnOrderForm.vue?vue&type=style&index=0&id=6177ae74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6177ae74"]])

export default __exports__